import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { CreateEntityButtonConfig } from 'record-it-components/pageContentLayout/ManageEntitiesContentLayout/ManageEntitiesContentLayout';
import { UserGroup } from '../../classes/entities/UserGroup/userGroupTypes';
import { UserGroupUtils } from '../../classes/entities/UserGroup/UserGroupUtils';
export function useUserGroupCreateEntityButtonConfig(t0) {
  const $ = _c(4);
  const {
    text,
    userGroups,
    onCreateEntity
  } = t0;
  let t1;
  if ($[0] !== onCreateEntity || $[1] !== text || $[2] !== userGroups) {
    t1 = {
      visible: true,
      dropdownItems: userGroups,
      getDropdownItemDisplayText: UserGroupUtils.displayTextGetter,
      getDropdownItemKey: UserGroupUtils.keyGetter,
      onCreateEntity,
      text
    };
    $[0] = onCreateEntity;
    $[1] = text;
    $[2] = userGroups;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}